<template>
  <div>
    <DialogBase
      v-model="inputValue"
      :title="
        $t('payment.payment_sale-payment-way') +
        (editMode ? $t('common.common_edit') : $t('common.common_register'))
      "
      :width="width"
    >
      <div class="px-5 pb-5">
        <InputFormNew
          v-model="inputData"
          :detail="items"
          :titleCols="inputFormStyle.titleCols"
          :contentsCols="inputFormStyle.contentsCols"
          :master-data="paymentMethod"
        />
        <NormalButton
          :text="buttonName"
          textSize="16px"
          height="50px"
          width="100%"
          class="pt-5"
          @click.native="complete()"
        />
      </div>
    </DialogBase>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import DialogBase from '@/components/layouts/Dialogs/DialogBase'
import { InputFormNew, NormalButton } from '@/components/items'
export default {
  components: {
    DialogBase,
    InputFormNew,
    NormalButton
  },
  props: {
    value: { default: false },
    width: { default: '540px' },
    buttonName: { default: 'common.input_save' },
    paymentMethodData: { type: Object, require: false, default: () => ({}) },
    editMode: { type: Boolean, require: false, default: false }
  },
  data: () => ({
    inputFormStyle: {
      titleCols: 3,
      contentsCols: 9
    },
    inputData: {},
    paymentMethod: [],
    items: [
      {
        name: 'name',
        text: 'payment.payment_sale-payment-way',
        required: true
      },
      {
        name: 'sortNumber',
        text: 'common.input_sort-number',
        required: true,
        placeholder: '',
        cols: Math.ceil(5),
        component: 'SelectSortNumber'
      },
      {
        name: 'isEnabled',
        text: 'product.product_display-setting',
        component: 'CheckEnabled'
      }
    ]
  }),

  created() {
    this.init()
  },

  methods: {
    ...mapActions('PaymentMethod', [
      'registerPaymentMethod',
      'editPaymentMethod'
    ]),
    ...mapGetters('PaymentMethod', [
      'getMaxSortNumber',
      'getPaymentMethodListFromState'
    ]),

    init() {
      const formatData = { ...this.paymentMethodData }
      // 新規登録の際に「表示する」項目のダイアログ初期値をtrueで設定
      if (!Object.keys(formatData).length) {
        formatData.isEnabled = true
      }
      formatData.sortNumber = this.editMode
        ? this.paymentMethodData.sortNumber
        : this.getMaxSortNumber() + 1

      this.inputData = formatData
      this.paymentMethod = this.getPaymentMethodListFromState()
    },
    async complete() {
      if (this.editMode) {
        this.inputData.id = this.inputData.paymentMethodId
      }
      const success = this.editMode
        ? await this.editPaymentMethod(this.inputData)
        : await this.registerPaymentMethod(this.inputData)

      if (success) {
        this.$emit('success')
      }
    }
  },
  computed: {
    inputValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  watch: {
    inputValue: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal) this.init()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.baseStyle {
  font-size: 14px;
}
</style>
